import React from "react";
import { AcademicCapIcon, ExternalLinkIcon } from "@heroicons/react/solid";
import { AcademicCapIcon as AcademicCapIconOutlined } from "@heroicons/react/outline";
import { achievements } from "../../data";
import MainIntersectProvider from "./../../MainIntersectProvider";

function Achievements() {
	return (
		<section id='achievements'>
			<div className='container px-5 xl:px-40 py-20 mx-auto'>
				<div className='text-center mb-20'>
					<MainIntersectProvider>
						<AcademicCapIcon className='w-10 inline-block mb-4' />
					</MainIntersectProvider>
					<h1 className='sm:text-3xl text-2xl font-medium title-font text-white mb-4'>
						Achievements Unlocked
					</h1>
				</div>
				<div className='grid md:grid-cols-3 grid-cols-1 gap-5'>
					{[...achievements].map(({ title, description, link }, index) => {
						return (
							<div
								className='flex flex-col justify-between relative border-2 cursor-default select-none hover:scale-105 transition-all transform-none ease-in-out md:transform-gpu border-gray-500 rounded-md p-5 w-full'
								key={index}
							>
								<AcademicCapIconOutlined className='w-32 opacity-5 z-10 text-gray-100 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2' />
								<div>
									<p className='text-lg text-yellow-500 font-semibold'>
										{title}
									</p>
									<p
										className='text-sm leading-relaxed font-normal pt-5'
										dangerouslySetInnerHTML={{ __html: description }}
									/>
								</div>
								{link && (
									<a href={link} target='__blank'>
										<ExternalLinkIcon className='w-6 cursor-pointer pt-4 text-gray-400 transition-all hover:text-blue-500' />
									</a>
								)}
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}

export default Achievements;
